import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import { RequireAdmin } from './components/RequireAdmin';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Products from './pages/Products';
import Orders from './pages/Orders';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import Vouchers from './pages/Vouchers';
import Login from './pages/Login';

function App() {
  return (
    <div className="app">
      <Header />
      <main>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <RequireAdmin>
                <Dashboard />
              </RequireAdmin>
            }
          />
          <Route
            path="/users"
            element={
              <RequireAdmin>
                <Users />
              </RequireAdmin>
            }
          />
          <Route
            path="/products"
            element={
              <RequireAdmin>
                <Products />
              </RequireAdmin>
            }
          />
          <Route
            path="/orders"
            element={
              <RequireAdmin>
                <Orders />
              </RequireAdmin>
            }
          />
          <Route
            path="/analytics"
            element={
              <RequireAdmin>
                <Analytics />
              </RequireAdmin>
            }
          />
          <Route
            path="/settings"
            element={
              <RequireAdmin>
                <Settings />
              </RequireAdmin>
            }
          />
          <Route
            path="/vouchers"
            element={
              <RequireAdmin>
                <Vouchers />
              </RequireAdmin>
            }
          />
        </Routes>
      </main>
      <footer className="footer">
        <p>Ludic Drive Assetstore — Admin Console</p>
      </footer>
    </div>
  );
}

export default App;
